import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { IActionItemCategory } from "./ActionItemCategory.types";

export const FETCH_ACTION_ITEM_CATEGORY_LIST_PROGRESS =
  "FETCH_ACTION_ITEM_CATEGORY_LIST_PROGRESS";
export const FETCH_ACTION_ITEM_CATEGORY_LIST_SUCCESS =
  "FETCH_ACTION_ITEM_CATEGORY_LIST_SUCCESS";
export const FETCH_ACTION_ITEM_CATEGORY_LIST_FAILED =
  "FETCH_ACTION_ITEM_CATEGORY_LIST_FAILED";

export const fetchActionItemCategoriesListProgress = () =>
  action(FETCH_ACTION_ITEM_CATEGORY_LIST_PROGRESS);
export const fetchActionItemCategoriesListSuccess = (
  data: IActionItemCategory[],
  totalRecords: number,
) => action(FETCH_ACTION_ITEM_CATEGORY_LIST_SUCCESS, { data, totalRecords });
export const fetchActionItemCategoriesListFailed = () =>
  action(FETCH_ACTION_ITEM_CATEGORY_LIST_FAILED);

export const fetchActionItemCategoriesListAsync =
  (
    companyOutletUuid: string,
    pageNumber: number,
    itemPerPage: number,
    pageLimit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue?: IDatatableV2AdvancedSearchFilter,
    searchByWord?: string,
    actionItemCategoryUuid?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(fetchActionItemCategoriesListProgress());
    try {
      dispatch(saveLoaderProgress());
      let searchQuery = "";

      // if (searchByWord) {
      //   searchQuery += `&word=${searchByWord}`;
      // }

      if (actionItemCategoryUuid) {
        searchQuery += `&action_item_category_uuid=${actionItemCategoryUuid}`;
      }

      if (searchValue?.length ?? 0) {
        const advanceFilter = [...(searchValue || [])];
        searchQuery += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      // searchQuery += `&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (status && status !== "-1") {
        searchQuery += `&status=${status}`;
      }

      const response = await api.get(
        `/conversation/get-action-item-category?company_outlet_uuid=${companyOutletUuid}&pageNo=${pageNumber}&pageLimit=${pageLimit}&itemPerPage=${itemPerPage}` +
          searchQuery,
      );
      const data: IActionItemCategory[] = response.data.data || [];

      const totalRecords = response.data.totalRecords || 0;
      dispatch(fetchActionItemCategoriesListSuccess(data, totalRecords));
    } catch (error) {
      dispatch(fetchActionItemCategoriesListFailed());
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertActionItemCategory =
  (
    data: IActionItemCategory,
    onCallback?: (isSuccess: boolean, data?: IActionItemCategory) => void,
  ) =>
  async (dispatch: any) => {
    try {
      dispatch(saveLoaderProgress());
      const response = await api.post(
        "/conversation/upsert-action-item-category",
        data,
      );
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "success",
          message: data.action_item_category_uuid
            ? "Action Item Category updated successfully"
            : "Action Item Category created successfully",
          displayAs: "snackbar",
        }),
      );
      onCallback?.(true, response.data);
      return response.data;
    } catch (error: any) {
      onCallback?.(false);
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "error",
          message:
            error.response?.data?.message ||
            "Failed to save Action Item Category",
          displayAs: "snackbar",
        }),
      );
    }
  };

export const CLEAR_ACTION_ITEM_CATEGORY_STATE =
  "CLEAR_ACTION_ITEM_CATEGORY_STATE";
export const clearActionItemCategoryState = () =>
  action(CLEAR_ACTION_ITEM_CATEGORY_STATE);
